import React from 'react'
import Container from './container'

function CloudServices() {
  // Array of cloud security services
  const securityServices = [
    'PROTEÇÃO DE APIS',
    'SCAN DE VULNERABILIDADES',
    'POLÍTICAS E GESTÃO DE ACESSOS',
    'MONITORAMENTO E COMPLIANCE',
    'PREVENÇÃO DE AMEAÇAS',
    'DEVSECOPS',
    'PROTEÇÃO DE DADOS',
    'MONITORAMENTO DE EVENTOS DE SEGURANÇA',
  ]

  return (
    <div className="w-full bg-[#040116] pt-14 pb-6 lg:pt-24 lg:pb-8">
      <Container className="flex flex-col lg:flex-row items-center space-y-12">
        <div className="w-full -ml-[48px] lg:w-1/3 lg:ml-24 flex justify-start pl-0 lg:mb-0 lg:scale-140">
          <img
            src="/assets/cloud.png"
            alt="Cloud Security"
            className="md:w-full object-cover lg:w-4/5 lg:max-w-xs"
          />
        </div>

        {/* Right section with services (2/3) */}
        <div className="w-2/3 grid grid-cols-1 lg:grid-cols-2 gap-6 pr-4 lg:pr-16">
          {securityServices.map((service, index) => (
            <div key={index} className="flex items-start">
              <img
                src="/assets/rainbow_arrow.svg"
                alt="Arrow"
                className="w-6 h-6 mt-1 mr-3"
              />
              <div>
                <h3 className="text-white text-sm md:text-xl font-inter-regular mt-[1px]">
                  {service}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default CloudServices
